import type {
    MemberNote,
    MemberNoteEditionInput,
    MemberNoteId,
    MissionNote,
    MissionNoteEditionInput,
    MissionNoteId,
    ResourceId,
} from '@wwf/sdk';
import { RAFile } from './types';

export type MemberNoteInput = MemberNoteEditionInput & {
    id?: MemberNoteId;
    attachmentsInput?: RAFile[];
};

export type MissionNoteInput = MissionNoteEditionInput & {
    id?: MissionNoteId;
    attachmentsInput?: RAFile[];
};

/** Supabase note attachment upload (RA file with bucket metadata). */
export type AttachmentNote = RAFile;

function attachmentIdsFromNote(note: {
    attachments?: { id: ResourceId }[] | null;
}): ResourceId[] {
    return note.attachments?.map(a => a.id) ?? [];
}

export function memberNoteToInput(note: MemberNote): MemberNoteInput {
    return {
        text: note.text ?? '',
        attachmentIds: attachmentIdsFromNote(note),
    };
}

export function missionNoteToInput(note: MissionNote): MissionNoteInput {
    return {
        text: note.text ?? '',
        attachmentIds: attachmentIdsFromNote(note),
    };
}
